import { EMPTY, throwError } from 'rxjs';
var serviceUnavailableCheck$ = global.ui.suspended ? throwError(Object.assign(new Error('Service unavailable'), {
  type: 'service-unavailable'
})) : EMPTY;
export default serviceUnavailableCheck$;